function initSingleLocationMap(elId, lat, lng, title){
    var myOptions = {
        zoom:15,
        center: new google.maps.LatLng(lat, lng),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        draggable: !("ontouchend" in document),
        scrollwheel: false
    };
    const map = new google.maps.Map(document.getElementById(elId), myOptions);
    const marker = new google.maps.Marker({map: map,position: new google.maps.LatLng(lat, lng)});
    const infowindow = new google.maps.InfoWindow({
        content:'<strong>' + title + '</strong>'
    });
    google.maps.event.addListener(marker, 'click', function(){
        infowindow.open(map,marker);
    });
    infowindow.open(map,marker);
}

export default initSingleLocationMap;


// WEBPACK FOOTER //
// ./public/javascripts/modules/contactMap.js